<template>
  <input
      class="rounded-xl p-2 w-full"
      :placeholder="placeholder"
      :type="type"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
  >
</template>

<script>
export default {
  props: ['placeholder', 'type', 'modelValue'],
  name: "Input"
}
</script>

<style scoped>

</style>